// src/components/Eventos/EventsHeats/components/EventHeader.jsx
import React from 'react';
import { Paper, Typography, Box, Chip, Alert, useTheme, useMediaQuery } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { getFontSize } from '../utils/eventHelpers';

const EventHeader = ({ 
  eventName, 
  eventNumber, 
  round, 
  genderLabel, 
  totalParts, 
  hasAnyResults 
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.down('md'));
  const isMd = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <>
      {/* Cabecera con información del evento */}
      <Paper
        elevation={0}
        variant="outlined"
        sx={{ 
          p: 2, 
          mb: 3,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
          opacity: 0.9
        }}
      >
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            fontSize: getFontSize(24, 1.25, isXs, isSm, isMd),
            fontWeight: 700,
            color: theme.palette.primary.main
          }}
        >
          {eventName}
        </Typography>
        
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap',
          gap: 1,
          mb: 1
        }}>
          <Chip 
            label={`Evento: ${eventNumber}`}
            variant="outlined"
            size={isXs ? "small" : "medium"}
            sx={{ fontSize: getFontSize(14, 1, isXs, isSm, isMd) }}
          />
          <Chip 
            label={`Ronda: ${round}`}
            variant="outlined"
            size={isXs ? "small" : "medium"}
            sx={{ fontSize: getFontSize(14, 1, isXs, isSm, isMd) }}
          />
          <Chip 
            label={`Rama: ${genderLabel}`}
            variant="outlined"
            size={isXs ? "small" : "medium"}
            sx={{ fontSize: getFontSize(14, 1, isXs, isSm, isMd) }}
          />
          <Chip 
            icon={<PersonIcon />}
            label={`${totalParts} participantes`}
            variant="outlined"
            size={isXs ? "small" : "medium"}
            sx={{ fontSize: getFontSize(14, 1, isXs, isSm, isMd) }}
          />
        </Box>
      </Paper>

      {/* Mensaje cuando no hay resultados */}
      {!hasAnyResults && (
        <Alert 
          severity="info" 
          variant="outlined"
          sx={{ 
            mb: 3,
            borderRadius: 2
          }}
        >
          <Typography variant="body1" sx={{ mb: 1 }}>
            Los resultados aún no están disponibles
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Los atletas aparecerán en los resultados generales una vez que tengan marcas registradas.
          </Typography>
        </Alert>
      )}
    </>
  );
};

export default EventHeader;